import { PropsWithChildren, createContext, useEffect, useState } from "react";

import { getRegionKey, isSupportedRegion } from "../region-utils";

/** Region context - provides a region.  */
export const RegionContext = createContext("");

/**
 * Provides the region key to the app. If the region is not supported, it will inject a supported region into the URL and redirect.
 * @param {PropsWithChildren} props
 * @returns {React.ReactElement}
 */
export function RegionProvider(props: PropsWithChildren) {
  const [region, setRegion] = useState(getRegionKey());

  function handleUrlChange() {
    const urlRegion = window.location.pathname.split("/")[1];

    if (!isSupportedRegion(urlRegion)) {
      window.location.replace(
        `/${getRegionKey()}${window.location.pathname}${window.location.search}`
      );
    }

    setRegion(getRegionKey());
  }

  useEffect(() => {
    handleUrlChange();

    window.addEventListener("popstate", handleUrlChange);

    return () => window.removeEventListener("popstate", handleUrlChange);
  }, []);

  return (
    <RegionContext.Provider value={region}>
      {props.children}
    </RegionContext.Provider>
  );
}
